import React from 'react';
import { Dialog, FlatButton } from 'material-ui';
import { FormattedMessage } from 'react-intl';

function ConfirmRole(props) {
  const actions = [
    <FlatButton label={<FormattedMessage id="questionnaire.no" />} primary={true} onClick={() => props.handleRoleConfirmation(false)} />,
    <FlatButton label={<FormattedMessage id="questionnaire.yes" />} primary={true} onClick={() => props.handleRoleConfirmation(true)} />,
  ];

  return (
    <Dialog
      actions={actions}
      modal={true}
      open={props.open}
    >
      <FormattedMessage id="emailAddressBook.confirmRole" />
    </Dialog>
  )
}

export default ConfirmRole;


// WEBPACK FOOTER //
// src/components/Seminars/ConfirmRole.js